var BaseDataStore = require("./BaseDataStore.js");
var ApplicationContext = require("../shared/config/ApplicationContext.js");

class BrowserDataStore extends BaseDataStore {
    /**
     * 
     * @param {String} url something like: /package/:id, /library/:id, /packages, 
     */
    getData(url, handleError) {
        var contentUrl = ApplicationContext.contentUrl() + url;

        var options = {
            credentials: "include"
        };

        return fetch(contentUrl, options)
            .then(res => {
                if (res.status == 200) {
                    return res.json()
                } else {
                    handleError(res, "retrieve page data");
                    throw err;
                }
            })
            .catch(err=>{
                handleError(null, "connect to server",  "Check your connection and try again.");
                throw err;
            })
    }

    doAuth(nextUrl = "/id-username/libraries") {
        const{ contentServer: {server, tenant} } = ApplicationContext;

        var redirectUrl =`${window.location.origin}/checkLoginSuccess?${nextUrl}`;
        var loginURL = `${server}/${tenant}/actions/login?tenant=circuits&redirect=${redirectUrl}`
        window.location = loginURL;
    }

    checkUserLoginThen(nextUrl) {
        return this.getUserInfo().then((succeed) => {
            if (succeed) {
                return succeed;
            } else {
                this.doAuth(nextUrl);
            }
        })
    }

    getUserInfo(handleError) {
        const { contentServer: { server, tenant } } = ApplicationContext;
        var userInfoUrl = `${server}/${tenant}/actions/userUsageInfoFromSession`;
        var options = {
            credentials: "include"
        };
        return fetch(userInfoUrl, options)
            .then(res => {
                if (res.status == 401){
                    // this will prompt the sign-in page, 
                    // no need to throw an error
                    return false;
                }
                else if (res.status == 200) {
                    return res.json().then((data) => {
                        ApplicationContext.setUserData(data);
                        return true;
                    })
                } else {
                    handleError(res, "retrieve user data");
                }
            })
            .catch(err=>{
                handleError(null, "connect to server",  "Check your connection and try again.");
            })
    }

    logoutUser() {
        // Invalidate the session cookie
        const date = new Date("01/01/1900").toUTCString();
        document.cookie = `CS_SESSION=logout;domain=.library.io;path=/;expires=${date};`;

        ApplicationContext.setUserData(undefined);

        const { contentServer: { server, tenant } } = ApplicationContext;
        const logoutUrl = `${server}/${tenant}/actions/logout?redirect=${window.location.origin}`;
        window.location.assign(logoutUrl);
    }
}

module.exports = BrowserDataStore;
